import React from 'react';
import CloseIcon from './close.svg';
import styles from './styles.module.css';
export const PopoverCloseButton = ({
  onClick,
  overlay
}) => {
  return /*#__PURE__*/React.createElement("button", {
    className: styles.PopoverCloseButton,
    onClick: onClick
  }, /*#__PURE__*/React.createElement(CloseIcon, {
    width: 20,
    height: 20
  }));
};
export default PopoverCloseButton;